
export const OfficesOptions =[
    { id: 'All', label: 'All' },
    { id: 'BJO', label: 'BJO' },
    { id: 'HKO', label: 'HKO' },
    { id: 'SGO', label: 'SGO' },
    { id: 'SHO', label: 'SHO' },
    { id: 'SZO', label: 'SZO' }
]

export const Status = [
    {id : 'All', label: 'All'},
    {id : 'PENDING', label: 'PENDING'},
    {id : 'REVIEW', label: 'REVIEW'},
    {id : 'READY', label: 'READY'},
    {id : 'SENDING', label: 'SENDING'},
    {id : 'SENT', label: 'SENT'},
    {id : 'ERROR' , label: 'ERROR'},
    {id : 'ARCHIVE_SENT' , label: 'ARCHIVE_SENT'},
    {id : 'ARCHIVE_ERROR', label: 'ARCHIVE_ERROR'},
    {id : 'NO_EMAIL' , label: 'NO_EMAIL'}
]

